export default "/images/vendor/flag-icon-css/flags/1x1/io.svg?c32d7f9e59460fb90af6fdf4c757a860";